module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-header",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.hiddenLogin
    }
  }), _vm._v("登录\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "login-input"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessToken),
      expression: "accessToken"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入Access Token"
    },
    domProps: {
      "value": (_vm.accessToken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accessToken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textBottom"
  })]), _vm._v(" "), _c('Buttons', {
    style: ({
      background: _vm.skinColor
    }),
    attrs: {
      "text": "登录"
    },
    on: {
      "click": function($event) {
        _vm.login(_vm.accessToken)
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-tips"
  }, [_c('ul', {
    staticClass: "tips"
  }, [_c('li', {
    staticClass: "tip"
  }, [_vm._v("为了更好的体验请登录"), _c('br', {
    staticClass: "br"
  }), _c('b', [_vm._v("（づ￣3￣）づ╭❤～")])]), _vm._v(" "), _c('li', {
    staticClass: "tip"
  }, [_vm._v("在"), _c('a', {
    staticClass: "title",
    attrs: {
      "href": "https://cnodejs.org"
    }
  }, [_vm._v("CNode官网")]), _vm._v("登录CNode账号")]), _vm._v(" "), _c('li', {
    staticClass: "tip"
  }, [_vm._v("在"), _c('a', {
    staticClass: "title",
    attrs: {
      "href": "https://cnodejs.org/setting"
    }
  }, [_vm._v("设置")]), _vm._v("中可以获取CNode账号的Access Token")]), _vm._v(" "), _c('li', {
    staticClass: "tip"
  }, [_c('img', {
    staticClass: "accessTokenImg",
    attrs: {
      "src": require("../../assets/img/Access Token.jpg"),
      "alt": "如何获取CNode账号的Access Token"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-17438454"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 326
// module chunks = 4